//import {useTranslation} from "react-i18next";

export default function Error(){
	
	return (
		<div id='error-page'>
			<div id='error-page-box'>
				<div className='title'>
					Error
				</div>
				<div className='mt-8 mb-4'>
					<a 
						id='error-button'
						href={window.referrer ? window.referrer : '/'}
					>
						<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="h-6 w-6">
            				<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16l-4-4m0 0l4-4m-4 4h18"></path>
        				</svg>						
					</a>
				</div>
			</div>
		</div>
	)
}